// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3XrI3","errorLogs":"styles_errorLogs__VXwp3"};